<template>
  <div class="mb-content">
    <Header />

    <!-- 移动端列表 -->
    <div class="zj-list">
      <div
        v-for="item in listData"
        :key="item.id"
        class="history-card"
        @click="detail(item.id,null)"
      >
        <img class="history-cover" :src="item.img" />
        <div class="history-body">
          <div class="history-title text-over2">{{ item.vname }}</div>
          <div class="history-status">{{ item.dqname || $t('history.watched') }}</div>
          <div class="history-footer">
            <div class="history-meta">{{ item.sum > item.episodes_total ? $t('history.ongoing') : $t('history.completed') }}</div>
            <div class="history-btn">{{ $t('history.continue') }}</div>
          </div>
        </div>
      </div>
      <div v-if="!listData.length && status !== 'loading'" class="empty-wrap">
        <div class="empty-text">{{ $t('history.empty') }}</div>
      </div>
    </div>

    <!-- 加载更多组件 -->
    <div class="load-more" v-if="listData.length > 0">
      <div v-if="status === 'loading'" class="load-tip">{{ $t('history.loading') }}</div>
      <div v-else-if="status === 'noMore'" class="load-tip">{{ $t('history.noMore') }}</div>
      <div v-else-if="status === 'more'" class="load-tip" @click="loadMore">{{ $t('history.loadMore') }}</div>
    </div>
    <div class="bottom-space"></div>
  </div>
</template>

<script>
import Header from "@/components/module/header.vue"; // 请根据实际路径调整
import {videoHstory} from "@/apis/user"
export default {
  name: "HistoryList",
  components: {
    Header,
  },
  data() {
    return {
      listData: [],
      query: {
        limit: 10,
        offset: 0,
      },
      total: 0,
      reload: true,
      status: "more", // more, loading, noMore
    };
  },
  mounted() {
    // 检查登录并加载数据
    this.checkLoginAndLoad();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkLoginAndLoad() {
      const userInfo = this.$getUserInfo();
      if (!userInfo || !userInfo.id) {
        this.$router.push("/login");
        return;
      }
      this.getList();
    },
    // 获取历史记录列表
    getList() {
      const userInfo = this.$getUserInfo();
      if (!userInfo || !userInfo.id) {
        this.$router.push("/login");
        return;
      }

      const params = {
        uid: userInfo.id,
        limit: this.query.limit,
        offset: this.query.offset,
      };

      videoHstory(params).then((res) => {
          const response = res || {};
          const rows = response.rows || [];
          const total = Number(response.total || 0);
          this.total = total;

          if (this.reload) {
            this.listData = rows;
            this.reload = false;
          } else {
            this.listData = this.listData.concat(rows);
          }

          if (!rows.length) {
            if (this.query.offset === 0) {
              this.listData = [];
              this.status = "noMore";
            } else {
              this.status = "noMore";
            }
            return;
          }

          if (this.listData.length >= total) {
            this.status = "noMore";
          } else {
            this.status = "more";
          }
        })
        .catch((err) => {
          console.error("获取历史记录失败", err);
          this.status = "more";
        });
    },
    // 重置并重新加载
    resetAndGetList() {
      this.listData = [];
      this.query.offset = 0;
      this.reload = true;
      this.status = "loading";
      this.getList();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    // 手动加载更多（点击“もっと読み込む”时调用）
    loadMore() {
      if (this.status === "loading" || this.status === "noMore") return;
      this.query.offset += 1;
      this.status = "loading";
      this.getList();
    },
    // 滚动到底部自动加载
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollTop + windowHeight >= documentHeight - 100) {
        if (this.status === "more" && this.listData.length > 0) {
          this.loadMore();
        }
      }
    },
    // 跳转详情
    detail(vid, mid) {
      let fxpid = 1;
      const userInfo = this.$getUserInfo();
      if (userInfo && userInfo.id) {
        fxpid = userInfo.id;
      }
      if (!mid) mid = 0;
      this.$router.push({
        path: "/video/details/details",
        query: { vid, mid, fxpid },
      });
    },
    // 供外部调用的方法（如需要）
    onPageChange() {
      this.resetAndGetList();
    },
    goDetail(item) {
      if (!item) return;
      this.detail(item.id, null);
    },
  },
};
</script>

<style scoped>
/* 基础样式（rpx 已转换为 px，按 2rpx = 1px 换算） */
.mb-content {
  width: 100%;
  max-width: 450px;
  min-height: 100vh;
  margin: 0 auto;
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
  transition: background 0.3s;
}

.light {
  background: #f5f5f7;
  color: #1d1d1f;
}

.dark {
  background: #181818;
  color: #f3f3f3;
}

/* 移动端列表容器 */
.zj-list {
  padding: 12px 12px 0 !important;
}

/* 历史卡片 */
.history-card {
  display: flex;
  align-items: flex-start;
  padding: 10px;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  backdrop-filter: none;
  position: relative;
  transition: transform 0.12s ease, background 0.12s ease;
}
.history-card:active {
  transform: scale(0.99);
  background: #f9f9fb;
}
.dark .history-card {
  background: rgba(40, 40, 40, 0.92);
  border-color: rgba(255, 255, 255, 0.06);
  box-shadow: none;
}

/* 封面 */
.history-cover {
  width: 76px;
  height: 102px;
  border-radius: 12px;
  background: #e5e5ea;
  flex-shrink: 0;
  object-fit: cover;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.07);
}
.dark .history-cover {
  background: #2b2b2b;
}

/* 右侧主体 */
.history-body {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
  min-height: 102px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 2px;
}

/* 标题 */
.history-title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  color: #1d1d1f;
  letter-spacing: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;          /* 添加标准属性 */
  overflow: hidden;
}
.dark .history-title {
  color: #f5f5f5;
}

/* 状态 */
.history-status {
  margin-top: 6px;
  font-size: 12px;
  color: #8e8e93;
  line-height: 1.4;
}
.dark .history-status {
  color: #a7a7a7;
}

/* 底部区域 */
.history-footer {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

/* 辅助信息 */
.history-meta {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #8e8e93;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dark .history-meta {
  color: #b7b7b7;
}

/* 按钮 */
.history-btn {
  height: 28px;
  padding: 0 11px;
  border-radius: 999px;
  background: #e8f2ff;
  color: #007aff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: none;
  cursor: pointer;
}
.history-btn:active {
  transform: scale(0.97);
  opacity: 0.92;
}
.dark .history-btn {
  background: #ffffff;
  color: #111111;
  box-shadow: none;
}

/* 空状态 */
.empty-wrap {
  padding: 64px 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.empty-text {
  font-size: 13px;
  font-weight: 500;
  color: #8e8e93;
  letter-spacing: 0;
}
.dark .empty-text {
  color: #9d9d9d;
}

/* 加载更多 */
.load-more {
  text-align: center;
  padding: 16px;
}
.load-tip {
  color: #8e8e93;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.dark .load-tip {
  color: #aaa;
}

.bottom-space {
  width: 100%;
  height: 24px;
}

/* 文本溢出（两行） */
.text-over2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;          /* 添加标准属性 */
  overflow: hidden;
}
</style>
